(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["campaign-banner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const pad = (n) => String(n).padStart(2, '0');

    const start = (el) => {
      if (el._campaignTimer) return;
      const deadline = new Date(el.dataset.deadline).getTime();
      if (Number.isNaN(deadline)) {
        el.hidden = true;
        return;
      }
      const values = {};
      el.querySelectorAll('[data-unit]').forEach((node) => {
        values[node.dataset.unit] = node;
      });
      const expired = el.querySelector('[data-campaign-expired]');

      const tick = () => {
        const diff = deadline - Date.now();
        if (diff <= 0) {
          clearInterval(el._campaignTimer);
          el.classList.add('is-expired');
          if (expired) expired.hidden = false;
          else el.hidden = true;
          return;
        }
        const total = Math.floor(diff / 1000);
        values.days.textContent = String(Math.floor(total / 86400));
        values.hours.textContent = pad(Math.floor((total % 86400) / 3600));
        values.minutes.textContent = pad(Math.floor((total % 3600) / 60));
        values.seconds.textContent = pad(total % 60);
      };

      tick();
      el._campaignTimer = setInterval(tick, 1000);
    };

    const init = (scope = document) => scope.querySelectorAll('[data-campaign-countdown]').forEach(start);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init());
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class DrHeader extends HTMLElement {
    connectedCallback() {
      this.isHome = this.dataset.home === 'true';
      this.desktopSolid = this.dataset.desktopSolid === 'true';
      this.mobileSolid = this.dataset.mobileSolid === 'true';
      this.desktopMq = window.matchMedia('(min-width: 1024px)');
      this.compact = false;
      this.openPanel = null;
      this.closeTimer = null;
      this.mobileSearch = this.querySelector('[data-mobile-search]');
      this.mobileToggle = this.querySelector('[data-mobile-search-toggle]');
      this.backdrop = this.querySelector('[data-mega-backdrop]');

      this.onScroll = () => {
        if (!this.frame) this.frame = requestAnimationFrame(() => this.readScroll());
      };
      this.onBreakpointChange = () => this.updateOverlay();
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.desktopMq.addEventListener('change', this.onBreakpointChange);
      this.readScroll();
      this.placeNav(this.compact);
      setTimeout(() => this.classList.add('motion-ready'), 1200);

      this.resizeObserver = new ResizeObserver(() => this.measure());
      this.resizeObserver.observe(this);
      this.measure();

      this.querySelectorAll('[data-mega-trigger]').forEach((trigger) => {
        const id = trigger.dataset.megaTrigger;
        trigger.addEventListener('pointerenter', (event) => {
          if (event.pointerType !== 'mouse') return;
          if (this.openPanel !== id) this.hoverOpened = true;
          this.open(id, trigger);
        });
        trigger.addEventListener('click', () => {
          if (this.openPanel === id && !this.hoverOpened) {
            this.close();
            return;
          }
          this.hoverOpened = false;
          this.open(id, trigger);
        });
        trigger.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowDown' || (event.key === 'Tab' && !event.shiftKey && this.openPanel === id)) {
            const first = this.panelLinks(id)[0];
            if (!first) return;
            event.preventDefault();
            this.open(id, trigger);
            first.focus();
          }
        });
      });
      this.querySelectorAll('[data-mega-close]').forEach((link) =>
        link.addEventListener('pointerenter', (event) => {
          if (event.pointerType === 'mouse') this.scheduleClose();
        })
      );
      this.querySelectorAll('[data-mega-panel], [data-category-nav]').forEach((el) => {
        el.addEventListener('mouseenter', () => this.cancelClose());
      });
      this.querySelectorAll('[data-mega-panel]').forEach((panel) => {
        panel.addEventListener('keydown', (event) => this.onPanelKey(event, panel));
        panel.addEventListener('mouseleave', (event) => {
          const next = event.relatedTarget;
          if (next instanceof Node && this.isMegaKeepOpenTarget(next)) return;
          this.scheduleClose();
        });
      });
      this.addEventListener('mouseleave', () => this.scheduleClose());
      this.addEventListener('focusin', (event) => {
        if (!this.openPanel || event.target === this.activeTrigger) return;
        if (event.target.closest('[data-category-nav]')) this.close();
      });
      this.addEventListener('focusout', (event) => {
        if (this.openPanel && !this.contains(event.relatedTarget)) this.close();
      });
      // Backdrop lives inside <dr-header>, so leaving the panel onto it never
      // fires header mouseleave — treat backdrop hover as outside the menu.
      this.backdrop?.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'mouse') this.scheduleClose();
      });
      this.backdrop?.addEventListener('click', () => this.close());

      this.onKeydown = (event) => {
        if (event.key !== 'Escape' || !this.openPanel) return;
        const returnFocus = this.contains(document.activeElement);
        const trigger = this.activeTrigger;
        this.close();
        if (returnFocus) trigger?.focus();
      };
      document.addEventListener('keydown', this.onKeydown);

      // Always open search — never toggle the bar closed. On homepage the bar
      // starts open, so a toggle would collapse it and require a second tap.
      this.mobileToggle?.addEventListener('click', () => this.setMobileSearch(true, true));

      this.onVisibility = () => {
        if (document.hidden) clearTimeout(this.typingTimer);
        else this.startTyping();
      };
      document.addEventListener('visibilitychange', this.onVisibility);
      this.startTyping();

      window.DrHeaderDialogs?.init();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      this.desktopMq?.removeEventListener('change', this.onBreakpointChange);
      document.removeEventListener('keydown', this.onKeydown);
      document.removeEventListener('visibilitychange', this.onVisibility);
      if (this.frame) cancelAnimationFrame(this.frame);
      this.resizeObserver?.disconnect();
      clearTimeout(this.typingTimer);
      clearTimeout(this.closeTimer);
    }

    panelLinks(id) {
      const panel = document.getElementById(id);
      return panel ? [...panel.querySelectorAll('a[href]')] : [];
    }

    onPanelKey(event, panel) {
      if (event.key !== 'Tab') return;
      const links = this.panelLinks(panel.id);
      if (!links.length || !this.activeTrigger) return;
      if (event.shiftKey && document.activeElement === links[0]) {
        event.preventDefault();
        this.activeTrigger.focus();
        return;
      }
      if (!event.shiftKey && document.activeElement === links[links.length - 1]) {
        event.preventDefault();
        const items = [...this.activeTrigger.closest('[data-category-nav]').querySelectorAll('.category-nav__item')];
        const next = items[items.indexOf(this.activeTrigger) + 1] || this.activeTrigger;
        this.close();
        next.focus();
      }
    }

    placeNav(compact) {
      const nav = this.querySelector('[data-category-nav]');
      const barSlot = this.querySelector('[data-nav-bar-slot]');
      const compactSlot = this.querySelector('[data-compact-nav]');
      if (!nav || !barSlot || !compactSlot) return;
      const target = compact ? compactSlot : barSlot;
      if (nav.parentElement !== target) target.append(nav);
      nav.classList.toggle('category-nav--compact', compact);
      nav.classList.toggle('no-scrollbar', !compact);
    }

    readScroll() {
      this.frame = 0;
      const y = window.scrollY;
      const next = !this.compact && y > 4 ? true : this.compact && y <= 0 ? false : this.compact;
      if (next === this.compact) return;
      this.compact = next;
      this.classList.toggle('is-compact', next);
      this.placeNav(next);
      if (next) this.setMobileSearch(false);
      else if (this.isHome) this.setMobileSearch(true);
      this.updateOverlay();
    }

    updateOverlay() {
      const solidDesktop = this.desktopSolid && this.desktopMq.matches;
      const solidMobile = this.mobileSolid && !this.desktopMq.matches;
      this.classList.toggle(
        'is-overlay',
        this.isHome && !this.compact && !this.openPanel && !solidDesktop && !solidMobile
      );
    }

    measure() {
      const height = Math.round(this.getBoundingClientRect().height);
      if (height) document.documentElement.style.setProperty('--dr-header-h', `${height}px`);
    }

    setMobileSearch(open, focus = false) {
      if (!this.mobileSearch) return;
      this.mobileSearch.classList.toggle('is-open', open);
      this.mobileToggle?.setAttribute('aria-expanded', String(open));
      if (open && focus) window.DR?.openDialog(document.getElementById('SearchModal'));
    }

    open(id, trigger) {
      this.cancelClose();
      if (trigger) this.activeTrigger = trigger;
      if (this.openPanel === id) return;
      this.querySelectorAll('[data-mega-panel]').forEach((panel) => {
        panel.hidden = panel.id !== id;
      });
      this.querySelectorAll('[data-mega-trigger]').forEach((trigger) => {
        trigger.setAttribute('aria-expanded', String(trigger.dataset.megaTrigger === id));
      });
      this.openPanel = id;
      this.classList.add('is-menu-open');
      this.updateOverlay();
    }

    close() {
      this.cancelClose();
      this.querySelectorAll('[data-mega-panel]').forEach((panel) => (panel.hidden = true));
      this.querySelectorAll('[data-mega-trigger]').forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
      this.openPanel = null;
      this.hoverOpened = false;
      this.classList.remove('is-menu-open');
      this.updateOverlay();
    }

    isMegaKeepOpenTarget(node) {
      return Boolean(node.closest('[data-mega-panel], [data-category-nav]'));
    }

    scheduleClose() {
      this.cancelClose();
      if (this.openPanel) this.closeTimer = setTimeout(() => this.close(), 180);
    }

    cancelClose() {
      clearTimeout(this.closeTimer);
      this.closeTimer = null;
    }

    startTyping() {
      const targets = this.querySelectorAll('[data-typing]');
      const phrases = (this.dataset.phrases || '')
        .split(',')
        .map((phrase) => phrase.trim())
        .filter(Boolean);
      if (!targets.length || !phrases.length || this.typingDone) return;
      clearTimeout(this.typingTimer);
      const prefix = this.dataset.prefix || '';
      const render = (text) => targets.forEach((el) => (el.textContent = `${prefix}${text}`));
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.typingDone = true;
        render(phrases[0]);
        return;
      }
      let phraseIndex = 0;
      let charIndex = 0;
      let deleting = false;
      const tick = () => {
        const full = phrases[phraseIndex];
        if (!deleting && phraseIndex === phrases.length - 1 && charIndex === full.length) {
          this.typingDone = true;
          return;
        }
        if (!deleting) {
          if (charIndex < full.length) {
            charIndex += 1;
            render(full.slice(0, charIndex));
            this.typingTimer = setTimeout(tick, 60);
          } else {
            this.typingTimer = setTimeout(() => {
              deleting = true;
              tick();
            }, 2200);
          }
        } else if (charIndex > 0) {
          charIndex -= 1;
          render(full.slice(0, charIndex));
          this.typingTimer = setTimeout(tick, 30);
        } else {
          phraseIndex = (phraseIndex + 1) % phrases.length;
          deleting = false;
          this.typingTimer = setTimeout(tick, 400);
        }
      };
      tick();
    }
  }

  if (!customElements.get('dr-header')) customElements.define('dr-header', DrHeader);

  (() => {
    if (window.DrHeaderDialogs) return;

    const initMenu = (menu) => {
      if (!menu || menu.dataset.ready) return;
      menu.dataset.ready = 'true';
      const main = menu.querySelector('[data-mobile-main]');
      const hideSubs = () => {
        menu.querySelectorAll('[data-mobile-sub]').forEach((panel) => {
          panel.hidden = true;
          panel.inert = true;
          panel.classList.remove('is-active');
        });
      };

      const reset = () => {
        main.inert = false;
        hideSubs();
        menu.querySelectorAll('[data-mobile-open]').forEach((button) => button.setAttribute('aria-expanded', 'false'));
      };
      menu.addEventListener('click', (event) => {
        const opener = event.target.closest('[data-mobile-open]');
        if (opener) {
          event.preventDefault();
          const panel = document.getElementById(opener.dataset.mobileOpen);
          if (!panel) return;
          hideSubs();
          main.inert = true;
          panel.hidden = false;
          panel.inert = false;
          panel.classList.add('is-active');
          opener.setAttribute('aria-expanded', 'true');
          panel.querySelector('[data-mobile-back]')?.focus();
          return;
        }
        const back = event.target.closest('[data-mobile-back]');
        if (back) {
          const panelId = back.closest('[data-mobile-sub]')?.id;
          reset();
          menu.querySelector(`[data-mobile-open="${panelId}"]`)?.focus();
        }
        if (event.target.closest('a[href]')) window.DR?.closeDialog(menu);
      });
      menu.addEventListener('close', reset);
    };

    const initSearch = (modal) => {
      if (!modal || modal.dataset.ready) return;
      modal.dataset.ready = 'true';
      const input = modal.querySelector('[data-search-input]');
      const results = modal.querySelector('[data-search-results]');
      const loading = modal.querySelector('[data-search-loading]');
      const status = modal.querySelector('[data-search-status]');
      const cache = new Map();
      let timer;
      let controller;

      modal.addEventListener('close', () => {
        clearTimeout(timer);
        controller?.abort();
        input.value = '';
        results.hidden = true;
        results.replaceChildren();
        loading.hidden = true;
        if (status) status.textContent = '';
      });

      const show = (html) => {
        results.innerHTML = html;
        results.hidden = false;
        const count = results.querySelectorAll('.predictive-search__chip, .predictive-search__product').length;
        if (status) status.textContent = count ? window.DR.plural('searchResults', count) : window.DR.t('searchNoResults');
      };

      const search = async (term) => {
        const key = term.toLowerCase();
        if (cache.has(key)) {
          show(cache.get(key));
          loading.hidden = true;
          return;
        }
        controller?.abort();
        controller = new AbortController();
        const url = `${window.DR.config.routes.predictiveSearch}?q=${encodeURIComponent(term)}&resources[type]=product,collection&resources[limit]=8&resources[limit_scope]=each&section_id=predictive-search`;
        try {
          const response = await fetch(url, { signal: controller.signal });
          if (!response.ok) throw new Error(response.statusText);
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const html = doc.querySelector('[data-predictive-search]')?.outerHTML || '';
          cache.set(key, html);
          if (input.value.trim().toLowerCase() === key) show(html);
        } catch (error) {
          if (error.name === 'AbortError') return;
          results.hidden = true;
        } finally {
          if (input.value.trim().toLowerCase() === key) loading.hidden = true;
        }
      };

      input.addEventListener('input', () => {
        clearTimeout(timer);
        const term = input.value.trim();
        if (term.length < 2) {
          controller?.abort();
          results.hidden = true;
          loading.hidden = true;
          return;
        }
        loading.hidden = false;
        timer = setTimeout(() => search(term), 300);
      });

      results.addEventListener('click', (event) => {
        if (event.target.closest('[data-search-submit]')) {
          event.preventDefault();
          modal.querySelector('[data-search-form]').requestSubmit();
        }
      });
    };

    document.addEventListener('click', (event) => {
      if (!event.target.closest('[data-search-open]')) return;
      const modal = document.getElementById('SearchModal');
      if (!modal) return;
      event.preventDefault();
      const mobileMenu = document.getElementById('MobileMenu');
      if (mobileMenu?.open) window.DR?.closeDialog(mobileMenu);
      window.DR?.openDialog(modal);
      requestAnimationFrame(() => modal.querySelector('[data-search-input]')?.focus());
    });

    window.DrHeaderDialogs = {
      init() {
        initMenu(document.getElementById('MobileMenu'));
        initSearch(document.getElementById('SearchModal'));
      },
    };

    window.DrHeaderDialogs.init();
    document.addEventListener('shopify:section:load', () => window.DrHeaderDialogs.init());
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initRotator = (rotator) => {
      if (rotator.hasAttribute('data-ready')) return;
      rotator.setAttribute('data-ready', '');
      const words = Array.from(rotator.children);
      const hero = rotator.closest('.hero');
      const toggle = hero?.querySelector('[data-rotator-toggle]');
      const controller = new AbortController();
      const { signal } = controller;
      const fit = (word) => {
        if (!word) return;
        // Always size to the full word. Never clip horizontally — the heading
        // line wraps "furniture." instead of shrinking "Occasional" to "Occas".
        rotator.style.width = 'max-content';
        const width = Math.ceil(word.scrollWidth || word.getBoundingClientRect().width);
        rotator.style.width = `${Math.max(width, 0)}px`;
      };
      if (words[0]) fit(words[0]);
      window.addEventListener('resize', () => fit(rotator.querySelector('.is-active') || words[0]), { signal });

      let timer = null;
      const stop = () => {
        clearInterval(timer);
        timer = null;
      };
      signal.addEventListener('abort', stop);

      document.addEventListener(
        'shopify:section:unload',
        (event) => {
          if (event.target.contains(rotator)) controller.abort();
        },
        { signal }
      );

      if (words.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      let index = words.findIndex((word) => word.classList.contains('is-active'));
      if (index < 0) index = 0;
      const interval = Number(rotator.dataset.interval) || 2800;
      const advance = () => {
        const current = words[index];
        index = (index + 1) % words.length;
        const next = words[index];
        fit(next);
        current.classList.add('is-leaving');
        current.classList.remove('is-active');
        next.classList.remove('is-leaving');
        next.classList.add('is-active');
        setTimeout(() => current.classList.remove('is-leaving'), 400);
      };
      const start = () => {
        if (!timer && toggle?.getAttribute('aria-pressed') !== 'true') timer = setInterval(advance, interval);
      };

      toggle?.addEventListener(
        'click',
        () => {
          const paused = toggle.getAttribute('aria-pressed') !== 'true';
          toggle.setAttribute('aria-pressed', String(paused));
          toggle.setAttribute(
            'aria-label',
            paused ? toggle.dataset.labelPlay || 'Play animation' : toggle.dataset.labelPause || 'Pause animation'
          );
          if (paused) stop();
          else start();
        },
        { signal }
      );
      document.addEventListener(
        'visibilitychange',
        () => {
          if (document.hidden) stop();
          else start();
        },
        { signal }
      );
      start();
    };

    const initAll = (scope = document) => scope.querySelectorAll('[data-rotator]').forEach(initRotator);
    initAll();
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  (() => {
    const renderStock = (root) => {
      const source = root.querySelector('[data-cart-stock]');
      if (!source || !window.DR?.delivery) return;
      let lines;
      try {
        lines = JSON.parse(source.textContent);
      } catch {
        return;
      }
      const entries = [];
      lines.forEach((line) => {
        const row = root.querySelector(`[data-cart-line][data-key="${CSS.escape(line.key)}"]`);
        const label = row?.querySelector('[data-line-stock]');
        const fallback = label?.dataset.fallback || '';
        if (label) label.textContent = window.DR.delivery.basketStockLabel(line.variant, line.tags, fallback);
        entries.push({ variant: line.variant, tags: line.tags, fallbackLabel: fallback });
      });
      const estimate = root.querySelector('[data-cart-estimate]');
      if (estimate && entries.length) {
        estimate.textContent = window.DR.delivery.basketDeliveryLabel(entries, estimate.dataset.fallback);
      }
    };

    const initCart = (root) => {
      if (root.hasAttribute('data-cart-ready')) return;
      root.setAttribute('data-cart-ready', '');
      const sectionId = root.dataset.sectionId;
      const status = root.parentElement?.querySelector('[data-cart-status]');
      const controller = new AbortController();
      const { signal } = controller;
      let busy = false;

      const restoreFocus = (focus) => {
        if (!focus) return;
        const line = root.querySelector(`[data-cart-line][data-key="${CSS.escape(focus.key)}"]`);
        const target =
          line?.querySelector(`[data-cart-control="${focus.control}"]`) ||
          root.querySelector('[data-cart-line] [data-cart-control]') ||
          root.querySelector('[data-cart-heading]');
        target?.focus();
      };

      const render = (html, focus) => {
        if (!html) {
          window.location.reload();
          return;
        }
        const next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart]');
        if (!next) {
          window.location.reload();
          return;
        }
        root.replaceChildren(...next.childNodes);
        window.DR?.init(root);
        renderStock(root);
        if (status) status.textContent = root.querySelector('[data-cart-count-text]')?.textContent.trim() || '';
        restoreFocus(focus);
      };

      const update = async (line, quantity, control) => {
        if (busy) return;
        busy = true;
        root.setAttribute('aria-busy', 'true');
        const focus = root.contains(document.activeElement) ? { key: line.dataset.key, control } : null;
        try {
          const data = await window.DR.cart.change(line.dataset.key, quantity, [sectionId]);
          render(data.sections?.[sectionId], focus);
        } catch (error) {
          window.DR?.toast(error.message, 'error');
        } finally {
          busy = false;
          root.removeAttribute('aria-busy');
        }
      };

      root.addEventListener('keydown', (event) => {
        if (event.key !== ' ' || !event.target.matches('[data-cart-quantity]')) return;
        event.preventDefault();
        event.target.click();
      });

      root.addEventListener('click', (event) => {
        const control = event.target.closest('[data-cart-quantity]');
        if (!control) return;
        event.preventDefault();
        const line = control.closest('[data-cart-line]');
        if (!line) return;
        const quantity = Number(control.dataset.cartQuantity);
        const max = line.dataset.max ? Number(line.dataset.max) : null;
        const warning = line.querySelector('[data-cart-max]');
        if (max !== null && quantity > max) {
          if (warning) warning.hidden = false;
          return;
        }
        if (warning) warning.hidden = true;
        update(line, Math.max(0, quantity), control.dataset.cartControl);
      });

      root.addEventListener('submit', (event) => {
        if (!event.target.matches('.main-cart__checkout')) return;
        event.target.querySelector('button[name="checkout"]')?.classList.add('is-loading');
      });

      window.addEventListener(
        'pageshow',
        (event) => {
          if (!event.persisted) return;
          root.querySelectorAll('.main-cart__checkout-button.is-loading').forEach((button) => button.classList.remove('is-loading'));
        },
        { signal }
      );

      document.addEventListener(
        'dr:cart-updated',
        async () => {
          if (busy) return;
          try {
            const response = await fetch(`${window.location.pathname}?section_id=${encodeURIComponent(sectionId)}`);
            if (response.ok && root.isConnected) render(await response.text());
          } catch {}
        },
        { signal }
      );

      document.addEventListener(
        'shopify:section:unload',
        (event) => {
          if (event.target.contains(root)) controller.abort();
        },
        { signal }
      );

      renderStock(root);

      // Shopify can keep stale discount allocations on the cart until the cart
      // mutates (checkout forces this). Re-post the same line quantities once so
      // disabled automatic discounts drop off without visiting checkout.
      const refreshStaleDiscounts = async () => {
        if (busy || root.dataset.discountRefreshDone) return;
        if (!root.querySelector('[data-cart-line]')) return;
        root.dataset.discountRefreshDone = '1';
        busy = true;
        root.setAttribute('aria-busy', 'true');
        try {
          const before = await window.DR.cart.refresh();
          if (!before?.item_count || !before.items?.length) return;
          const updates = Object.fromEntries(before.items.map((item) => [item.key, item.quantity]));
          const after = await window.DR.cart.update(updates, [sectionId]);
          if (
            after.total_discount !== before.total_discount ||
            after.total_price !== before.total_price
          ) {
            render(after.sections?.[sectionId]);
          }
        } catch {
          // Non-fatal: cart still usable with whatever Shopify last cached.
        } finally {
          busy = false;
          root.removeAttribute('aria-busy');
        }
      };

      refreshStaleDiscounts();
    };

    const initAll = (scope = document) => scope.querySelectorAll('[data-cart]').forEach(initCart);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (() => {
    const initCollection = (root) => {
      if (root.hasAttribute('data-collection-ready')) return;
      root.setAttribute('data-collection-ready', '');

      const sectionId = root.dataset.sectionId;
      const form = root.querySelector('[data-filter-form]');
      const panel = root.querySelector('[data-filter-panel]');
      const toggle = root.querySelector('[data-filter-open]');
      const status = root.querySelector('[data-collection-status]');
      const desktop = window.matchMedia('(min-width: 1024px)');
      const controller = new AbortController();
      const { signal } = controller;
      let requestId = 0;
      let observer = null;
      let priceTimer = null;

      const focusables = () =>
        [...panel.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')].filter(
          (el) => !el.disabled && el.offsetParent !== null
        );

      const openFilters = () => {
        root.classList.add('filters-open');
        document.documentElement.classList.add('has-dialog');
        panel.setAttribute('role', 'dialog');
        panel.setAttribute('aria-modal', 'true');
        toggle?.setAttribute('aria-expanded', 'true');
        panel.querySelector('.collection-filters__close')?.focus();
      };

      const closeFilters = (returnFocus = true) => {
        if (!root.classList.contains('filters-open')) return;
        root.classList.remove('filters-open');
        document.documentElement.classList.remove('has-dialog');
        panel.removeAttribute('role');
        panel.removeAttribute('aria-modal');
        toggle?.setAttribute('aria-expanded', 'false');
        if (returnFocus) toggle?.focus();
      };

      const activeField = () => {
        const el = document.activeElement;
        if (!el || !form.contains(el) || !el.name) return null;
        return {
          name: el.name,
          value: el.type === 'checkbox' ? el.value : null,
          text: el.type === 'number' ? el.value : null,
        };
      };

      const restoreField = (field) => {
        if (!field) return;
        let selector = `[name="${CSS.escape(field.name)}"]`;
        if (field.value !== null) selector += `[value="${CSS.escape(field.value)}"]`;
        const target = form.querySelector(selector);
        if (!target) return;
        if (field.text !== null) target.value = field.text;
        target.focus();
      };

      const sectionUrl = (url) => {
        const target = new URL(url, window.location.origin);
        target.searchParams.set('section_id', sectionId);
        return target.toString();
      };

      const fetchDocument = async (url) => {
        const response = await fetch(sectionUrl(url));
        if (!response.ok) throw new Error(response.statusText);
        return new DOMParser().parseFromString(await response.text(), 'text/html');
      };

      const loadMore = async (link) => {
        if (link.classList.contains('is-loading')) return;
        link.classList.add('is-loading');
        const id = requestId;
        try {
          const doc = await fetchDocument(link.href);
          if (id !== requestId || !link.isConnected) return;
          const grid = root.querySelector('[data-product-grid]');
          const items = doc.querySelectorAll('[data-product-grid] > *');
          grid.append(...items);
          const nextHost = doc.querySelector('[data-load-more-host]');
          const host = root.querySelector('[data-load-more-host]');
          if (nextHost && host) host.replaceWith(nextHost);
          window.DR?.init(grid);
          watchLoadMore();
        } catch {
          link.classList.remove('is-loading');
        }
      };

      const watchLoadMore = () => {
        observer?.disconnect();
        const link = root.querySelector('[data-load-more]');
        if (!link || !('IntersectionObserver' in window)) return;
        observer = new IntersectionObserver(
          (entries) => {
            if (entries.some((entry) => entry.isIntersecting)) loadMore(link);
          },
          { rootMargin: '400px' }
        );
        observer.observe(link);
      };

      const render = async (url, push = true) => {
        const id = ++requestId;
        root.classList.add('is-loading');
        try {
          const doc = await fetchDocument(url);
          if (id !== requestId) return;
          const field = activeField();
          root.querySelectorAll('[data-collection-swap]').forEach((el) => {
            const next = doc.querySelector(`[data-collection-swap="${el.dataset.collectionSwap}"]`);
            if (next) el.replaceWith(next);
          });
          const select = doc.querySelector('select[name="sort_by"]');
          if (select) form.querySelector('select[name="sort_by"]').value = select.value;
          if (push) window.history.pushState({ collection: sectionId }, '', url);
          window.DR?.init(root);
          watchLoadMore();
          restoreField(field);
          if (status) status.textContent = root.querySelector('[data-collection-swap="count"]')?.textContent.trim() || '';
        } catch {
          window.location.href = url;
        } finally {
          if (id === requestId) root.classList.remove('is-loading');
        }
      };

      const formUrl = () => {
        const params = new URLSearchParams();
        new FormData(form).forEach((value, key) => {
          if (String(value).trim() !== '') params.append(key, value);
        });
        const minKey = 'filter.v.price.gte';
        const maxKey = 'filter.v.price.lte';
        const min = parseFloat(params.get(minKey));
        const max = parseFloat(params.get(maxKey));
        if (min > max) {
          params.set(minKey, String(max));
          params.set(maxKey, String(min));
        }
        return `${window.location.pathname}?${params}`;
      };

      form.addEventListener('change', (event) => {
        if (event.target.type === 'number') return;
        render(formUrl());
      });

      form.addEventListener('input', (event) => {
        if (event.target.type !== 'number') return;
        clearTimeout(priceTimer);
        priceTimer = setTimeout(() => render(formUrl()), 700);
      });

      form.addEventListener('submit', (event) => {
        event.preventDefault();
        render(formUrl());
      });

      root.addEventListener('click', (event) => {
        const link = event.target.closest('[data-collection-link]');
        if (link) {
          event.preventDefault();
          render(link.href);
          return;
        }
        const more = event.target.closest('[data-load-more]');
        if (more) {
          event.preventDefault();
          loadMore(more);
          return;
        }
        if (event.target.closest('[data-filter-open]')) {
          openFilters();
          return;
        }
        if (event.target.closest('[data-filter-close]')) closeFilters();
      });

      document.addEventListener(
        'keydown',
        (event) => {
          if (!root.classList.contains('filters-open')) return;
          if (event.key === 'Escape') {
            closeFilters();
            return;
          }
          if (event.key !== 'Tab') return;
          const items = focusables();
          if (!items.length) return;
          const first = items[0];
          const last = items[items.length - 1];
          if (!panel.contains(document.activeElement)) {
            event.preventDefault();
            first.focus();
          } else if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        },
        { signal }
      );

      desktop.addEventListener(
        'change',
        (event) => {
          if (event.matches) closeFilters(false);
        },
        { signal }
      );

      window.history.replaceState({ ...(window.history.state || {}), collection: sectionId }, '');
      window.addEventListener(
        'popstate',
        (event) => {
          if (event.state?.collection !== sectionId) return;
          render(window.location.href, false);
        },
        { signal }
      );

      document.addEventListener(
        'shopify:section:unload',
        (event) => {
          if (!event.target.contains(root)) return;
          closeFilters(false);
          observer?.disconnect();
          clearTimeout(priceTimer);
          controller.abort();
        },
        { signal }
      );

      watchLoadMore();
    };

    const initAll = (scope = document) => scope.querySelectorAll('[data-collection]').forEach(initCollection);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initProduct = (root) => {
      if (root.hasAttribute('data-product-ready')) return;
      root.setAttribute('data-product-ready', '');

      const data = JSON.parse(root.querySelector('[data-product-json]').textContent);
      const form = root.querySelector('form[action*="/cart/add"]');
      const qtyValue = root.querySelector('[data-qty-value]');
      const qtyInput = root.querySelector('[data-qty-input]');
      const qtyPlus = root.querySelector('[data-qty-plus]');
      const message = root.querySelector('[data-stock-message]');
      const addedDialog = root.querySelector('[data-added-dialog]');
      const addedQty = root.querySelector('[data-added-qty]');
      let quantity = 1;
      let requestId = 0;

      const addButton = () => root.querySelector('[data-add-to-cart]');

      const rule = () => {
        const button = addButton();
        const min = Math.max(1, Number(button?.dataset.qtyMin) || 1);
        const step = Math.max(1, Number(button?.dataset.qtyStep) || 1);
        const max = Number(button?.dataset.qtyMax) || Infinity;
        return { min, step, max };
      };

      const stockLimit = () => {
        const button = addButton();
        const inBasket = Number(button?.dataset.inBasket || 0);
        const stock = button?.dataset.stockMax ? Number(button.dataset.stockMax) : Infinity;
        return Math.max(0, Math.min(stock, rule().max) - inBasket);
      };

      const setMessage = (text) => {
        message.textContent = text || '';
        message.hidden = !text;
      };

      const setQuantity = (value) => {
        quantity = value;
        qtyValue.textContent = String(value);
        qtyInput.value = String(value);
        qtyPlus.disabled = quantity + rule().step > stockLimit();
      };

      const resetQuantity = () => setQuantity(rule().min);

      const onlyAvailable = () => {
        const button = addButton();
        const stock = button?.dataset.stockMax ? Number(button.dataset.stockMax) : Infinity;
        return root.dataset.messageOnly.replace('__QUANTITY__', String(Math.min(stock, rule().max)));
      };

      root.querySelector('[data-qty-minus]').addEventListener('click', () => {
        const { min, step } = rule();
        setQuantity(Math.max(min, quantity - step));
        setMessage('');
      });

      qtyPlus.addEventListener('click', () => {
        const { step } = rule();
        if (quantity + step > stockLimit()) {
          setMessage(onlyAvailable());
          return;
        }
        setQuantity(quantity + step);
        setMessage('');
      });

      document.addEventListener('dr:cart-updated', (event) => {
        const cart = event.detail?.cart;
        const button = addButton();
        if (!root.isConnected || !cart?.items || !button) return;
        const variantId = Number(button.dataset.variantId);
        const count = cart.items
          .filter((item) => item.variant_id === variantId)
          .reduce((sum, item) => sum + item.quantity, 0);
        button.dataset.inBasket = String(count);
        setQuantity(quantity);
      });

      const slides = root.querySelectorAll('[data-gallery-slide]');
      const thumbs = root.querySelectorAll('[data-gallery-thumb]');
      let currentIndex = data.selectedIndex || 0;

      const zoomToggle = root.querySelector('.product-gallery__zoom');
      const galleryCounter = root.querySelector('[data-gallery-counter]');

      const showSlide = (index) => {
        currentIndex = index;
        slides.forEach((slide, i) => {
          const active = i === index;
          if (!active && !slide.hidden) slide.querySelectorAll('video').forEach((video) => video.pause());
          slide.hidden = !active;
        });
        thumbs.forEach((thumb, i) => thumb.setAttribute('aria-pressed', String(i === index)));
        if (galleryCounter) galleryCounter.textContent = `${index + 1} / ${slides.length}`;
        if (zoomToggle) zoomToggle.hidden = slides[index]?.dataset.mediaType !== 'image';
      };

      if (root.querySelector('[data-product-model]')) {
        window.Shopify?.loadFeatures?.([
          {
            name: 'model-viewer-ui',
            version: '1.0',
            onLoad: (error) => {
              if (error) return;
              root.querySelectorAll('model-viewer').forEach((model) => {
                if (!model._drUi && window.Shopify?.ModelViewerUI) model._drUi = new window.Shopify.ModelViewerUI(model);
              });
            },
          },
        ]);
      }

      thumbs.forEach((thumb) => thumb.addEventListener('click', () => showSlide(Number(thumb.dataset.galleryThumb))));

      const frame = root.querySelector('.product-gallery__frame');
      const mobileGallery = window.matchMedia('(max-width: 639px)');
      let swipeStart = null;
      let swipedAt = 0;

      if (frame && slides.length > 1) {
        frame.addEventListener('touchstart', (event) => {
          if (!mobileGallery.matches || event.touches.length > 1) return;
          swipeStart = { x: event.touches[0].clientX, y: event.touches[0].clientY };
        }, { passive: true });

        frame.addEventListener('touchend', (event) => {
          if (!swipeStart) return;
          const touch = event.changedTouches[0];
          const dx = touch.clientX - swipeStart.x;
          const dy = touch.clientY - swipeStart.y;
          swipeStart = null;
          if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
          swipedAt = Date.now();
          const step = dx < 0 ? 1 : -1;
          showSlide((currentIndex + step + slides.length) % slides.length);
          thumbs[currentIndex]?.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
        });

        frame.addEventListener('click', (event) => {
          if (Date.now() - swipedAt < 400) {
            event.preventDefault();
            event.stopPropagation();
          }
        }, true);
      }

      const lightbox = root.querySelector('[data-lightbox]');
      if (lightbox && data.images.length) {
        const image = lightbox.querySelector('[data-lightbox-image]');
        const counter = lightbox.querySelector('[data-lightbox-counter]');
        const zoomButton = lightbox.querySelector('[data-lightbox-zoom]');
        const stage = lightbox.querySelector('[data-lightbox-stage]');
        let index = 0;
        let touchStartX = null;

        const setZoom = (zoomed, origin = '50% 50%') => {
          image.style.transformOrigin = origin;
          lightbox.classList.toggle('is-zoomed', zoomed);
          zoomButton.setAttribute('aria-label', zoomed ? zoomButton.dataset.labelOut : zoomButton.dataset.labelIn);
        };

        const render = () => {
          const current = data.images[index];
          image.src = current.src;
          image.alt = current.alt;
          counter.textContent = `${index + 1} / ${data.images.length}`;
          setZoom(false);
        };

        const go = (step) => {
          index = (index + step + data.images.length) % data.images.length;
          render();
        };

        root.addEventListener('click', (event) => {
          const opener = event.target.closest('[data-lightbox-open]');
          if (!opener || !root.contains(opener)) return;
          const target = opener.dataset.lightboxOpen;
          index = target === 'current' ? currentIndex : Number(target);
          render();
          DR.openDialog(lightbox);
        });

        zoomButton.addEventListener('click', () => setZoom(!lightbox.classList.contains('is-zoomed')));
        lightbox.querySelector('[data-lightbox-prev]')?.addEventListener('click', () => go(-1));
        lightbox.querySelector('[data-lightbox-next]')?.addEventListener('click', () => go(1));

        image.addEventListener('click', (event) => {
          event.stopPropagation();
          if (lightbox.classList.contains('is-zoomed')) {
            setZoom(false);
            return;
          }
          const rect = image.getBoundingClientRect();
          const x = ((event.clientX - rect.left) / rect.width) * 100;
          const y = ((event.clientY - rect.top) / rect.height) * 100;
          setZoom(true, `${x}% ${y}%`);
        });

        stage.addEventListener('click', (event) => {
          if (event.target === stage) DR.closeDialog(lightbox);
        });

        lightbox.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') go(-1);
          if (event.key === 'ArrowRight') go(1);
        });

        stage.addEventListener('touchstart', (event) => {
          touchStartX = event.touches[0]?.clientX ?? null;
        }, { passive: true });

        stage.addEventListener('touchend', (event) => {
          if (touchStartX === null || lightbox.classList.contains('is-zoomed')) return;
          const delta = (event.changedTouches[0]?.clientX ?? 0) - touchStartX;
          touchStartX = null;
          if (Math.abs(delta) > 50) go(delta > 0 ? -1 : 1);
        });
      }

      const lockBuyButton = (label) => {
        const add = addButton();
        if (!add) return;
        add.disabled = true;
        add.setAttribute('aria-busy', 'true');
        if (label) add.querySelector('[data-add-label]').textContent = label;
      };

      const swapSections = async (variantId) => {
        const id = ++requestId;
        const url = `${data.url}?variant=${variantId}&section_id=${root.dataset.sectionId}`;
        lockBuyButton();
        try {
          const response = await fetch(url);
          if (!response.ok) throw new Error(String(response.status));
          const html = await response.text();
          if (id !== requestId) return;
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const nextBuy = doc.querySelector('[data-product-swap="buy"] [data-add-to-cart]');
          if (!nextBuy || nextBuy.dataset.variantId !== String(variantId)) throw new Error('variant mismatch');
          root.querySelectorAll('[data-product-swap]').forEach((el) => {
            const next = doc.querySelector(`[data-product-swap="${el.dataset.productSwap}"]`);
            if (next) el.replaceWith(next);
          });
          DR.init(root);
          resetQuantity();
        } catch {
          if (id !== requestId) return;
          lockBuyButton(root.dataset.labelUnavailable);
          setMessage(root.dataset.messageVariantError);
        }
      };

      root.addEventListener('click', (event) => {
        const button = event.target.closest('[data-option-value]');
        if (!button || !root.contains(button)) return;
        const group = button.closest('[data-option-group]');
        group.querySelectorAll('[data-option-value]').forEach((b) => b.setAttribute('aria-pressed', String(b === button)));
        group.querySelector('[data-option-selected]').textContent = button.dataset.optionValue;

        const selected = Array.from(root.querySelectorAll('[data-option-group]')).map(
          (g) => g.querySelector('[data-option-value][aria-pressed="true"]')?.dataset.optionValue
        );
        const variant = data.variants.find((v) => v.options.every((value, i) => value === selected[i]));
        setMessage('');

        if (!variant) {
          requestId += 1;
          lockBuyButton(root.dataset.labelUnavailable);
          addButton()?.removeAttribute('aria-busy');
          return;
        }

        const params = new URLSearchParams(window.location.search);
        params.set('variant', variant.id);
        window.history.replaceState({}, '', `${window.location.pathname}?${params}`);
        if (variant.media !== null) showSlide(variant.media);
        swapSections(variant.id);
      });

      const related = root.querySelector('[data-added-related]');
      let relatedRequest = null;

      const fetchRelated = async (url) => {
        const response = await fetch(url);
        if (!response.ok) return {};
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const host = doc.querySelector('[data-added-recommendations]');
        const list = host?.querySelector('.added-related__list');
        list?.querySelector(`[data-handle="${CSS.escape(related.dataset.handle)}"]`)?.remove();
        Array.from(list?.children ?? []).slice(3).forEach((item) => item.remove());
        return { list: list?.children.length ? list : null, rangeSearch: host?.dataset.rangeSearch };
      };

      const fetchRangeRelated = async () => {
        try {
          const { list, rangeSearch } = await fetchRelated(related.dataset.rangeUrl);
          if (list || !rangeSearch) return list;
          return (await fetchRelated(related.dataset.searchUrl + encodeURIComponent(rangeSearch))).list;
        } catch {
          return null;
        }
      };

      const loadRelated = () => {
        if (!related || relatedRequest) return;
        relatedRequest = (async () => {
          try {
            const list =
              (await fetchRangeRelated()) ??
              (await fetchRelated(`${related.dataset.url}&intent=complementary`)).list ??
              (await fetchRelated(`${related.dataset.url}&intent=related`)).list;
            if (!list) return;
            related.querySelector('[data-added-related-list]').replaceChildren(list);
            related.hidden = false;
          } catch {
            relatedRequest = null;
          }
        })();
      };

      related?.addEventListener('click', async (event) => {
        const button = event.target.closest('[data-added-related-add]');
        if (!button || button.disabled) return;
        const label = button.querySelector('[data-added-related-label]');
        const originalLabel = label.textContent;
        button.disabled = true;
        label.textContent = related.dataset.labelAdding;
        try {
          await DR.cart.add([{ id: Number(button.dataset.addedRelatedAdd), quantity: 1 }]);
          button.classList.add('is-added');
          button.querySelector('.icon')?.remove();
          label.textContent = related.dataset.labelAdded;
        } catch (error) {
          button.disabled = false;
          label.textContent = originalLabel;
          DR.toast(error.message, 'error');
        }
      });

      form?.addEventListener('submit', async (event) => {
        event.preventDefault();
        const button = addButton();
        if (!button || button.disabled) return;
        const limit = stockLimit();
        if (limit <= 0) {
          setMessage(root.dataset.messageMax);
          return;
        }
        if (quantity > limit) {
          setMessage(onlyAvailable());
          return;
        }

        const label = button.querySelector('[data-add-label]');
        const originalLabel = label.textContent;
        button.disabled = true;
        button.classList.add('is-loading');
        label.textContent = root.dataset.labelAdding;
        setMessage('');
        loadRelated();

        try {
          await DR.cart.add([{ id: Number(button.dataset.variantId), quantity }]);
          addedQty.textContent = root.dataset.labelQuantity.replace('__QUANTITY__', quantity);
          addedQty.hidden = quantity <= 1;
          DR.openDialog(addedDialog);
          resetQuantity();
        } catch (error) {
          DR.toast(error.message, 'error');
        } finally {
          button.disabled = false;
          button.classList.remove('is-loading');
          label.textContent = originalLabel;
        }
      });

      resetQuantity();
    };

    const initAll = (scope = document) => scope.querySelectorAll('[data-product]').forEach(initProduct);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  (() => {
    const init = (root) => {
      const scope = root.querySelector('[data-main-search]') || root;
      const input = scope.querySelector('[data-search-input]');
      const clear = scope.querySelector('[data-search-clear]');

      if (input && clear) {
        input.addEventListener('input', () => {
          clear.hidden = input.value === '';
        });
        clear.addEventListener('click', () => {
          const hadTerms = input.defaultValue !== '';
          input.value = '';
          clear.hidden = true;
          if (hadTerms) {
            input.form.requestSubmit();
          } else {
            input.focus();
          }
        });
      }

      const sort = scope.querySelector('[data-search-sort]');
      if (sort) {
        sort.querySelector('select').addEventListener('change', () => sort.requestSubmit());
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init(document));
    } else {
      init(document);
    }
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-range"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const loadRange = async (placeholder) => {
      if (placeholder.hasAttribute('data-loading')) return;
      placeholder.setAttribute('data-loading', '');
      try {
        const response = await fetch(placeholder.dataset.url);
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const content = doc.querySelector('[data-range-content]');
        if (!content) return;
        const slides = () => content.querySelectorAll('[data-carousel-track] > [data-handle]');
        slides().forEach((slide) => {
          if (slide.dataset.handle === placeholder.dataset.exclude) slide.remove();
        });
        slides().forEach((slide, index) => {
          if (index >= 8) slide.remove();
        });
        if (!slides().length) return;
        const head = content.querySelector('.product-carousel__head');
        if (head && placeholder.dataset.eyebrow) {
          const eyebrow = document.createElement('span');
          eyebrow.className = 'eyebrow';
          eyebrow.textContent = placeholder.dataset.eyebrow;
          head.prepend(eyebrow);
        }
        const host = placeholder.closest('[data-range-content]');
        host.replaceChildren(...content.childNodes);
        window.DR?.init(host);
      } catch {
        placeholder.remove();
      }
    };

    const init = (scope = document) => {
      scope.querySelectorAll('[data-range-deferred]').forEach((placeholder) => {
        if (window.DR?.onVisible) window.DR.onVisible(placeholder, () => loadRange(placeholder), '600px 0px');
        else loadRange(placeholder);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init());
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const load = async (host) => {
      if (host.hasAttribute('data-loading') || !host.dataset.url) return;
      host.setAttribute('data-loading', '');
      try {
        const response = await fetch(host.dataset.url);
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const content = doc.querySelector('[data-recommendations]');
        if (!content) return;
        const slideSelector = '[data-carousel-track] > [data-handle]';
        const taken = new Set(
          Array.from(document.querySelectorAll(`[data-range-content] ${slideSelector}`)).map((slide) => slide.dataset.handle)
        );
        content.querySelectorAll(slideSelector).forEach((slide) => {
          if (taken.has(slide.dataset.handle)) slide.remove();
        });
        content.querySelectorAll(slideSelector).forEach((slide, index) => {
          if (index >= 8) slide.remove();
        });
        if (!content.querySelector(slideSelector)) return;
        host.replaceChildren(...content.childNodes);
        window.DR?.init(host);
      } catch {
        host.removeAttribute('data-loading');
      }
    };

    const init = (scope = document) => {
      scope.querySelectorAll('[data-recommendations]').forEach((host) => {
        if (host.querySelector('[data-carousel-track] > [data-handle]')) return;
        if (window.DR?.onVisible) window.DR.onVisible(host, () => load(host), '600px 0px');
        else load(host);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init());
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
